import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import Modal from 'react-modal';
// import {ThemeProvider} from 'styled-components';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {ThemeProvider, createTheme} from '@mui/material/styles';

import _kc from './utils/keycloak';
import _axios from './utils/axios';
import {store, persistor} from './store';
import App from './App';

// eslint-disable-next-line import/no-webpack-loader-syntax
// const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!./styles/variables.scss');
// const theme = {
//   jellyBean: 'red',
//   gamboge: 'pink',
//   cultured50: 'green',
//   cultured: 'blue'
// };

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      paper: '#282840',
      default: '#282840'
    }
  },
});

Modal.setAppElement('#root');

_kc.init({  // initialize the keycloak
  onLoad: 'login-required',
  checkLoginIframe: false
}).then(() =>  // insert the token into axios requests
  _axios.interceptors.request.use((config) =>
    _kc.token ?
      _kc.updateToken(5)
      .then(() => {
        config.headers.Authorization = `Bearer ${_kc.token}`;
        return Promise.resolve(config);
      }) :
      config
  )
).then(() =>  // render the app
  ReactDOM.render(
    <React.StrictMode>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={darkTheme}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <BrowserRouter>
                {/* <ThemeProvider theme={theme}> */}
                  <App/>
                {/* </ThemeProvider> */}
              </BrowserRouter>
            </PersistGate>
          </Provider>
        </ThemeProvider>
      </LocalizationProvider>
    </React.StrictMode>,
    document.getElementById('root')
  )
);
